// clipboardHelper.ts
export const copyToClipboard = (
  text: string,
  setState: (stateUpdate: object) => void
) => {
  navigator.clipboard.writeText(text)
    .then(() => {
      setState({
        snackbarOpen: true,
        snackbarMessage: "Copied to clipboard!",
      });
    })
    .catch((err) => {
      console.error("Failed to copy: ", err);
      setState({
        snackbarOpen: true,
        snackbarMessage: "Failed to copy.",
      });
    });
};
